import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const ProtectedRoutes = ({ children }) => {
  const navigate = useNavigate();
  const [auth, setAuth] = useState(false);
  const [loading, setLoading] = useState(true);

  axios.defaults.withCredentials = true;

  useEffect(() => {
    axios.get("http://localhost:8081/dashboard")
      .then(res => {
        if (res.data.Status === "Succuss") {
          setAuth(true);
        } else {
          setAuth(false);
          navigate("/admin-login");
        }
        setLoading(false);
      })
      .catch(() => {
        setAuth(false);
        navigate("/admin-login");
        setLoading(false);
      });
  }, [navigate]);

  if (loading) {
    return <div>
        <h4 className="m-5">Loading...</h4>
    </div>;
  }

  return auth ? children : null;
};

export default ProtectedRoutes;
